class ChartController {}

export default ChartController;
